export default __webpack_public_path__ + "static/rec-2016-b5c7eb8dc9752cdabb048840170c7c02.png";